import React from 'react';
import { Typography, Modal, Button, Box } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { makeStyles } from '@material-ui/core/styles';
import { DetailsEditComponent } from './EditComponent';

const useStyles = makeStyles(() => ({
  detailsBox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    backgroundColor: 'white',
    border: '1px solid #fff',
    borderRadius: '20px',
    padding: '20px',
    boxShadow: 24,
  },
}));

const ViewComponent = (props) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  return (
    <td style={{ textAlign: 'right' }}>
      <Button onClick={() => setOpen(true)} style={{ padding: '6px 16px' }}>
        <VisibilityIcon />
      </Button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="view-modal-title"
        aria-describedby="view-modal-description"
      >
        <Box className={classes.detailsBox} style={{ maxHeight: '100vh', overflowY: 'auto' }}>
          <DetailsEditComponent
            {...props}
            non_editable_fields={props.view_fields}
            editable_fields={[]}
            info_banner_items={[]}
          />
        </Box>
      </Modal>
    </td>
  );
};

export default ViewComponent;